import { gql } from 'apollo-angular';

export const jobOffer = gql`
	fragment JobOffer on JobOfferOutput {
		id
		title
		owner {
			id
		}
		keyPoints
		companyName
		documentUrl
		contractType
		modulesColumn {
			moduleColumnId
			organizationModuleId
		}
	}
`;
